
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../../common/client/components/Text';

import SelectOpsubComboBox from './SelectOpsubComboBox';

const classNames = mergeStyleSets({
    SelectOpsub: {
        paddingTop: 16
    }
});

const SelectOpsub = ({
    opsubItem,
    opsubItems,
    onChange
}) => {

    const handleChangeOpsub = (opsubItem) => {
        onChange(opsubItem);
    }

    return (
        <Stack className={classNames.SelectOpsub} tokens={{childrenGap: 16}}>
            <>
                <Stack horizontal>
                    <Stack.Item grow>Počet načtených vlastníků: {opsubItems.length}</Stack.Item>
                </Stack>
                <SelectOpsubComboBox
                    opsubItem={opsubItem}
                    opsubItems={opsubItems}
                    onChange={handleChangeOpsub}
                />
            </>
            {(opsubItem)
                ? <Stack>
                    <Text bold>Vybraný vlastník</Text>
                    <Stack horizontal wrap tokens={{childrenGap: 4}}>
                        <Text>{opsubItem._name}, </Text>
                        <Text>{opsubItem._rcico}, </Text>
                        <Text>{opsubItem._address}</Text>
                    </Stack>
                </Stack>
                : null
            }
        </Stack>
    );
}

export default SelectOpsub;
